import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Card,
  CardHeader,
  Divider,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@material-ui/core';
import Label from "../../../components/Label";

const useStyles = makeStyles((theme) => ({
  root: {},
  fontWeightMedium: {
    fontWeight: theme.typography.fontWeightMedium,
  },
}));

const BasicsInfo = ({
                      chapter,
                      className,
                      ...rest
                    }) => {
  const classes = useStyles();
  return (
      <Card
          className={clsx(classes.root, className)}
          {...rest}
      >
        <CardHeader title="Traineeship info"/>
        <Divider/>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className={classes.fontWeightMedium}>
                ID
              </TableCell>
              <TableCell>
                <Typography
                    variant="body2"
                    color="textSecondary"
                >
                  {chapter.id}
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.fontWeightMedium}>
                Name
              </TableCell>
              <TableCell>
                <Typography
                    variant="body2"
                    color="textSecondary"
                >
                  {chapter.name }
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.fontWeightMedium}>
                Subjects
              </TableCell>
              <TableCell>
                {chapter.traineeship_subjects?.map((subject) => (
                    <Label color='warning'>
                      {subject.subject.division.name+' |'+subject.subject.name}
                    </Label>
                ))}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.fontWeightMedium}>
                Levels
              </TableCell>
              <TableCell>
                {chapter.traineeship_levels?.map((level) => (
                    <Typography
                        variant="body2"
                        color="textSecondary"
                    >
                      {level.level.name}
                    </Typography>
                ))}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.fontWeightMedium}>
                Groups
              </TableCell>
              <TableCell>
                {chapter.traineeship_groups?.map((group) => (
                    <Typography
                        variant="body2"
                        color="textSecondary"
                    >
                      {group.group.name}
                    </Typography>
                ))}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.fontWeightMedium}>
                Price
              </TableCell>
              <TableCell>
                <Label color='success'>
                  {chapter.price}
                </Label>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.fontWeightMedium}>
                Created At
              </TableCell>
              <TableCell>
                <Typography
                    variant="body2"
                    color="textSecondary"
                >
                  {chapter.created_at}
                </Typography>
              </TableCell>
            </TableRow>

          </TableBody>
        </Table>
      </Card>
  );
};

BasicsInfo.propTypes = {
  className: PropTypes.string,
  chapter: PropTypes.object.isRequired,
};

export default BasicsInfo;
